import axios from 'axios';

// const API_BASE_URL = 'http://localhost:8000/api/';
const API_BASE_URL = '/api/';

// const token = localStorage.getItem('token');

export const apiInstance = axios.create({
    baseURL: API_BASE_URL,
    // headers: {Authorization: `Token ${token}`},
});

// added a request interceptor to include the token in the header of all requests
apiInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        // console.log('Token from localStorage:', token);
        if (token) {
            config.headers['Authorization'] = `Token ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const loginUser = async (username, password) => {
    try {
        // const response = await axios.post("http://localhost:8000/api/login/", {
        //     username,
        //     password
        // });
        const response = await axios.post("/api/login/", { username, password });

        // console.log({username, password});

        if (response.data && response.data.token) {
            localStorage.setItem('token', response.data.token);
            return response.data.token;
        } else {
            console.error('Token not found in response:', response.data);
            throw new Error('Token not found in response');
        }

    } catch (error) {
        // handle error
        console.error('Error logging in:', error);
        throw error;
    }
};

export const fetchUsers = async () => {
    try {
        const response = await apiInstance.get('/users/');
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchChatMessages = async () => {
    const response = await apiInstance.get('/chat-messages/');
    return response.data;
};

export const sendChatMessage = async ({ recipient, body, to_all = false }) => {
    const response = await apiInstance.post('/chat-messages/', { recipient, body, to_all });
    return response.data;
};

export const fetchUnreadChatCount = async () => {
    const response = await apiInstance.get('/chat-messages/unread-count/');
    return response.data.count || 0;
};

export const markChatMessagesRead = async () => {
    const response = await apiInstance.post('/chat-messages/mark-read/');
    return response.data;
};

export const fetchProductPriceAlerts = async () => {
    const response = await apiInstance.get('/product-price-alerts/');
    return response.data;
};

export const clearProductPriceAlert = async (alertId) => {
    const response = await apiInstance.post(`/product-price-alerts/${alertId}/clear/`);
    return response.data;
};

export const clearAllProductPriceAlerts = async () => {
    const response = await apiInstance.post('/product-price-alerts/clear-all/');
    return response.data;
}

export const fetchUserDetails = async () => {
    try {
        const response = await apiInstance.get('/user/profile/');
        return response.data; // should include 'is_superuser' and 'groups' keys
    } catch(error) {
        console.error('Error fetching user details:', error);
        throw error;
    }
};

export const updateUserDetails = async (userData) => {
    try {
        const response = await apiInstance.put('/user/profile/', userData);
        return response.data;
    } catch (error) {
        console.error('Error updating user details:', error);
        throw error;
    }
};

export const fetchAuditLogs = async (filters, page = 1, pageSize = 20) => {
    try {
        const params = new URLSearchParams({
            ...filters,
            page: page,
            page_size: pageSize,
        });
        const response = await apiInstance.get(`/audit-logs/?${params.toString()}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching audit logs:', error);
        throw error;
    }
};

// store logic
export const fetchStores = async () => {
    const response = await apiInstance.get('/stores/?active_only=true');
    return response.data;
};

export const setActiveStore = async (storeId) => {
    const response =await apiInstance.post('/set-store/', { store_id: storeId });
    return response.data;
};

export const fetchCurrentStore = async () => {
    const response = await apiInstance.get('/current-store/');
    return response.data;
};

export const fetchStoreStock = async (page = 1, search = '') => {
    const response = await apiInstance.get(`/store-stock/?page=${page}&search=${search}`);
    return response.data;
};

export const fetchPurchases = async (page = 1, filters = {},  pageSize) => {
    try {
        const params = new URLSearchParams();
        params.append('page', page);

        // ask the server for more rows if the caller supplied a value
        if (pageSize) params.append('page_size', pageSize);

        // if the user provided start_date/end_date, payment method or supplier
        if (filters.start_date) params.append('start_date', filters.start_date);
        if (filters.end_date) params.append('end_date', filters.end_date);

        // for partial searching with DRF "search" param
        if (filters.searchTerm) params.append('search', filters.searchTerm);

        const response = await apiInstance.get(`/purchases/?${params.toString()}`);
        // response will have {count, next, previous, results} due to DRF pagination
        return {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
            results: response.data.results,
        }
    } catch (error) {
        console.error('Error fetching purchases:', error);
        throw error;
    }
}

export const createPurchase = async (newPurchase) => {
    const response = await apiInstance.post('/purchases/', newPurchase);
    return response.data;
};
// for the rest as well, handle errors at the highest level possible, at the UI (react), hence the try/catch removal

export const updatePurchase = async (purchase) => {
    if (!purchase.id) {
        throw new Error('Purchase ID is required for update.');
    }

    try {
            const response = await apiInstance.patch(`/purchases/${purchase.id}/`, purchase);
            return response.data;
        } catch (error) {
            console.error('Error updating purchase:', error);
            throw error;
        }
    };

// export const deletePurchase = async (purchaseId) => {
//     try {
//         await apiInstance.delete(`/purchases/${purchaseId}/`);
//     } catch (error) {
//         console.error('Error deleting purchase:', error);
//         throw error;
//     }
// };

export const fetchSuppliers = async () => {
    try {
        const response = await apiInstance.get('/suppliers');
        return response.data;
    } catch (error) {
        console.error('Error fetching suppliers:', error);
        throw error;
    }
};

export const addSupplier = async (newSupplier) => {
    try {
        const response = await apiInstance.post('/suppliers/', newSupplier);
        return response.data;
    } catch (error) {
        console.error('Error adding supplier:', error);
        throw error;
    }
};

export const updateSupplier = async (supplier) => {
    try {
        const response = await apiInstance.put(`/suppliers/${supplier.id}/`, supplier);
        return response.data;
    } catch (error) {
        console.error('Error updating supplier:', error);
        throw error;
    }
};

export const deleteSupplier = async (supplierId) => {
    try {
        await apiInstance.delete(`/suppliers/${supplierId}/`);
        // no return since delete request does not return any data
    } catch (error) {
        console.error('Error deleting supplier:', error);
        throw error;
    }
};

// to be used in pos.js
export const fetchProducts = async (page=1, searchTerm= '', categoryId= '') => {
    try {
        // added
        const params = { page };
        if (searchTerm) params.search = searchTerm;
        if (categoryId) params.category = categoryId;
        // end of added
        const response = await apiInstance.get('/products/', { params });
        const data = response.data;

        // console.log('Products fetched:', data);

        // return response.data.map(product => ({
        if (data && Array.isArray(data.results)) {
            return {
                count: data.count,
                results: data.results.map(product => ({
                    id: product.id,
                    name: product.product_name,
                    price: parseFloat(product.retail_price) || 0.00,
                    retail_price: parseFloat(product.retail_price) || 0.00, // for use in units in drop down list
                    wholesale_price: parseFloat(product.wholesale_price) || 0.00,
                    cost_price: parseFloat(product.cost_price) || 0.00,
                    stock: parseFloat(product.stock) || 0.0,
                    categoryId: product.category_id,
                    base_unit: product.base_unit || null,
                    selectedQuantity: 1, //initialize with a default quantity of 1
                    is_vat_applicable: product.is_vat_applicable,

                    units: product.units.map(unit => ({
                        ...unit,
                        unit_price: parseFloat(unit.unit_price) || 0.00,
                        unit_wholesale_price: parseFloat(unit.unit_wholesale_price) || 0.00,
                        conversion_factor: parseFloat(unit.conversion_factor) || 1.0,
                    })) || [],
                    // end of added
                    selectedUnitId: null,
                    conversion_factor: 1.0,
                    unit_price: parseFloat(product.retail_price) || 0.00,
                    unitCostPrice: parseFloat(product.cost_price) || 0.00,
                }))
            };
        } else {
            console.error('Invalid products data structure:', data);
            return { count: 0, results: [] };
        }
    } catch (error) {
        console.error('Error fetching products:', error);
        return { count: 0, results: [] }; // Fallback to prevent undefined
    }
}

// New Cart API functions
export const fetchCart = async () => {
    const response = await apiInstance.get('/cart/current_cart/');
    return response.data;
}

export const addToCartApi = async (product) => {
    const response = await apiInstance.post('/cart/add_item/', {
        product: product.id,
        unit_id: product.selectedUnitId,
        quantity: product.selectedQuantity,
        price: product.price,
    });
    return response.data;
}

export const removeFromCartApi = async (item_id) => {
    const response = await apiInstance.delete('/cart/remove_item/', { data: { item_id } });
    return response.data;
}

export const clearCartApi = async () => {
    const response = await apiInstance.delete('/cart/clear_cart/');
    return response.data;
}

export const setCartDiscountApi = async (discount) => {
    const response = await apiInstance.post('/cart/set_discount/', { discount });
    return response.data;
};

export const fetchCategoriesApi = async () => {
    try {
        const response = await apiInstance.get('/categories');
        // return response.data.map(category => ({
        //     value: category.id,
        //     name: category.category_name
        // }));
        return response.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
}

export const addCategoryApi = async (newCategory) => {
    try {
        const response = await apiInstance.post('/categories/', newCategory);
        return response.data;
    } catch (error) {
        console.error('Error adding category:', error);
    }
}

export const updateCategoryApi = async (category) => {
    try {
        const response = await apiInstance.put(`/categories/${category.id}/`, category);
        return response.data;
    } catch (error) {
        console.error('Error updating category:', error);
    }
}

export const deleteCategoryApi = async (categoryId) => {
    try {
        await apiInstance.delete(`/categories/${categoryId}/`);
        // no return since delete request does not return any data
    } catch (error) {
        console.error('Error deleting category:', error);
    }
}

// added for stock tracing
export const fetchStockLedger = async (filters = {}, page = 1, pageSize = 50) => {
    try {
        const params = new URLSearchParams({
            ...filters,
            page,
            page_size: pageSize,
        });
        const response = await apiInstance.get(`/stock-ledger/?${params.toString()}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching stock ledger:', error);
        throw error;
    }
};
// end of added

export const fetchCustomers = async () => {
    try {
        // const apiInstance = getApiInstance();
        const response = await apiInstance.get('/customers');
        return response.data;
    } catch (error) {
        console.error('Error fetching customers:', error);
    }
};

export const addCustomer = async (customer) => {
    try {
        // const apiInstance = getApiInstance();
        const response = await apiInstance.post('/customers/', customer);
        return response.data;
    } catch (error) {
        console.error('Error adding customer:', error);
    }
};

// update customer
export const updateCustomer = async (customer) => {
    try {
        // const apiInstance = getApiInstance();
        const response = await apiInstance.put(`/customers/${customer.id}/`, customer);
        return response.data;
    } catch (error) {
        console.error('Error updating customer:', error);
    }
};

// delete customer
export const deleteCustomer = async (customerId) => {
    try {
        // const apiInstance = getApiInstance();
        await apiInstance.delete(`/customers/${customerId}/`);
        // no return since delete request does not return any data
    } catch (error) {
        console.error('Error deleting customer:', error);
    }
};

// export const updateCustomerBalance = async (customerId, newBalance) => {
//     try {
//         const response = await apiInstance.put(`/customers/${customerId}/update-balance/`, {customer_balance: newBalance});
//         return response.data;
//     } catch (error) {
//         console.error('Error updating customer balance:', error);
//     }
// };

// product.js apis, for use in product page
export const fetchProduct = async (page = 1, searchTerm = '', categoryFilter = '') => {
    try {
        const params = { page };
        if (searchTerm) params.search = searchTerm;
        if (categoryFilter) params.category = categoryFilter;

        const response = await apiInstance.get('/products', { params });
        // return response.data;
        return response.data;
    } catch (error) {
        console.error('Error fetching product:', error);
    }
};

export const fetchUnitsOfMeasure = async () => {
    try {
        const response = await apiInstance.get('/units-of-measure');
        return response.data;
    } catch (error) {
        console.error('Error fetching units of measure:', error);
    }
};

export const addUnitOfMeasure = async (newUnit) => {
    try {
        const response = await apiInstance.post('/units-of-measure/', newUnit);
        return response.data;
    } catch (error) {
        console.error('Error adding unit of measure:', error);
    }
};

export const updateUnitOfMeasure = async (unitId, updatedUnit) => {
    try {
        const response = await apiInstance.put(`/units-of-measure/${unitId}/`, updatedUnit);
        return response.data;
    } catch (error) {
        console.error('Error updating unit of measure:', error);
    }
};

export const deleteUnitOfMeasure = async (unitId) => {
    try {
        await apiInstance.delete(`/units-of-measure/${unitId}/`);
    } catch (error) {
        console.error('Error deleting unit of measure:', error);
    }
}

export const adjustStock = async (productId, adjustData) => {
    try {
        const response = await apiInstance.post(`/products/${productId}/adjust_stock/`, adjustData);
        return response.data;
    } catch (error) {
        console.error('Error adjusting stock:', error);
        throw error;
    }
};

// for use in purchase page
export const fetchProductsForPurchase = async () => {
    try {
        const response = await apiInstance.get('/products/all-minimal-with-units/');
        return response.data.map(product => ({
            value: product.id,
            label: product.product_name,
            base_unit: product.base_unit,
            units: product.units || [],
            last_purchase_price_base:
                product.last_purchase_price_base !== null && product.last_purchase_price_base !== undefined
                    ? parseFloat(product.last_purchase_price_base)
                    : null,
        }));
    } catch (error) {
        console.error('Error fetching products for purchase:', error);
        throw error; // Re-throw the error to handle it in calling functions
    }
};

export const addProduct = async (product) => {
    try {
        // const apiInstance = getApiInstance();
        const response = await apiInstance.post('/products/', product);
        console.log('API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error adding product:', error);
        if (error.response && error.response.data) {
            console.error('Server responded with:', error.response.data);
        }
    }
}

export const updateProduct = async (product) => {
    try {
        const response = await apiInstance.put(`/products/${product.id}/`, product);
        return response.data;
    } catch (error) {
        console.error('Error updating product:', error);
    }
}

export const deleteProduct = async (productId) => {
    try {
        await apiInstance.delete(`/products/${productId}/`);
        // no return since delete request does not return any data
    } catch (error) {
        console.error('Error deleting product:', error);
    }
}

export const fetchOrder = async (page = 1, filters = {}, pageSize) => {
    try {
        const params = new URLSearchParams();
        // always include the page
        params.append('page', page);
        // added
        if (pageSize) params.append('page_size', pageSize);
        // end of added

        // if user provided a date range, payment method, or customer, pass them
        if (filters.start_date) params.append('start_date', filters.start_date);
        if (filters.end_date) params.append('end_date', filters.end_date);
        if (filters.payment_method) params.append('payment_method', filters.payment_method);
        if (filters.served_by) params.append('served_by', filters.served_by);

        // for partial searching on customer_name or order_number
        if (filters.searchTerm) {
            params.append('search', filters.searchTerm);
        }
        if (filters.orderNumberFilter) {
            params.append('order_number', filters.orderNumberFilter);
        }

        // make the GET request with query params
        const response = await apiInstance.get(`/orders/?${params.toString()}`);

        return {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
            results: response.data.results,
        };
    } catch (error) {
        console.error('Error fetching orders:', error);
        throw error;
    }
};

// added for reprint
export const fetchSingleOrder = async (orderId) => {
    try {
        const response = await apiInstance.get(`/orders/${orderId}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching order:', error);
        throw error;
    }
};
// end of added

export const createOrder = async (orderData) => {
    try {
        console.log('Sending orderData:', orderData);
        const response = await apiInstance.post('/orders/', orderData);
        return response.data;
    } catch (error) {
        console.error('Error creating order:', error);
        throw error;
    }
}

export const updateOrder = async (orderData) => {
    try {
        // const apiInstance = getApiInstance();
        const response = await apiInstance.put(`/orders/${orderData.id}/`, orderData);
        return response.data;
    } catch (error) {
        console.error('Error updating order:', error.response ? error.response.data : error);
        throw error;
    }
}

export const deleteOrder = async (orderId) => {
    try {
        // const apiInstance = getApiInstance();
        await apiInstance.delete(`/orders/${orderId}/`);
        // no return since delete request does not return any data
    } catch (error) {
        console.error('Error deleting order:', error);
    }
}

export const createOrderReturn = async (returnData) => {
    try {
        // console.log('Sending returnData:', returnData);
        const response = await apiInstance.post('/orderreturns/', returnData);
        console.log('Return response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error creating order return:', error);
    }
}

export const fetchReturnedOrders = async (page = 1, filters = {}, pageSize) => {
    try {
        const params = new URLSearchParams();
        params.append('page', page);
        if (pageSize) params.append('page_size', pageSize);

        if (filters.start_date) params.append('start_date', filters.start_date);
        if (filters.end_date) params.append('end_date', filters.end_date);

        if (filters.searchTerm)
            params.append('search', filters.searchTerm);

        const response = await apiInstance.get(`/orderreturns/?${params.toString()}`);

        return response.data;

    } catch (error) {
        console.error('Error fetching returned orders:', error);
        throw error;
    }
};

export const fetchAccountTypes = async () => {
    try {
        const response = await apiInstance.get('/accounttypes/');
        return response.data;
    } catch (error) {
        console.error('Error fetching account types:', error);
    }
};

export const createAccountType = async (accountType) => {
    try {
        const response = await apiInstance.post('/accounttypes/', accountType);
        return response.data;
    } catch (error) {
        console.error('Error creating account type:', error);
    }
}

export const updateAccountType = async (accountType) => {
    try {
        const response = await apiInstance.put(`/accounttypes/${accountType.id}/`, accountType);
        return response.data;
    } catch (error) {
        console.error('Error updating account type:', error);
    }
};

export const deleteAccountType = async (accountTypeId) => {
    try {
        await apiInstance.delete(`/accounttypes/${accountTypeId}/`);
    } catch (error) {
        console.error('Error deleting account type:', error);
    }
};

export const fetchAccounts = async () => {
    try {
        const response = await apiInstance.get('/accounts/');
        // console.log('API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching accounts:', error);
    }
}

export const createAccount = async (accountData) => {
    try {
        const response = await apiInstance.post('/accounts/', accountData);
        return response.data;
    } catch (error) {
        console.error('Error creating account:', error);
    }
}

export const updateAccount = async (accountData) => {
    try {
        const response = await apiInstance.put(`/accounts/${accountData.id}/`, accountData);
        return response.data;
    } catch (error) {
        console.error('Error updating account:', error);
    }
}

export const deleteAccount = async (accountId) => {
    try {
        await apiInstance.delete(`/accounts/${accountId}/`);
    } catch (error) {
        console.error('Error deleting account:', error);
    }
};

export const fetchFinancialYears = async () => {
    const response = await apiInstance.get('/financial-years/');
    return response.data;
};

export const createFinancialYear = async (payload) => {
    const response = await apiInstance.post('/financial-years/', payload);
    return response.data;
};

export const closeFinancialYear = async (id) => {
    const response = await apiInstance.post(`/financial-years/${id}/close/`);
    return response.data;
};
// end of added

export const fetchTransactions = async (page = 1, pageSize = 20, filters = {}) => {
    try {
        // build query params
        const params = new URLSearchParams({
            page: page.toString(),
            page_size: pageSize.toString(),
        });

        if (filters.start_date) params.append('start_date', filters.start_date);
        if (filters.end_date)   params.append('end_date', filters.end_date);
        if (filters.expense_only) params.append('expense_only', 'true');

        const url = `/transactions/?${params.toString()}`;
        console.log('Fetching transactions from:', url);
        const response = await apiInstance.get(url);
        return response.data; // => { count, next, previous, results: [...] }
    } catch (error) {
    console.error('Error fetching transactions:', error);
    }
};

export const fetchLedger = async (page=1, pageSize=20, filters={}) => {
    try {
        // build query
        const params = new URLSearchParams({
            page: String(page),
            page_size: String(pageSize),
        });

        if (filters.account_id) params.append('account_id', filters.account_id);
        if (filters.start_date) params.append('start_date', filters.start_date);
        if (filters.end_date) params.append('end_date', filters.end_date);

        const url = `/ledger/?${params.toString()}`;
        console.log('Fetching ledger from:', url);
        const response = await apiInstance.get(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching ledger:', error);
        throw error;
    }
};

export const exportLedgerPdf = async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.account_id) params.append('account_id', filters.account_id);
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.scope) params.append('scope', filters.scope);

    return await apiInstance.get(`/ledger/export-pdf/?${params.toString()}`, {
        responseType: 'blob',
    });
};

export const createTransaction = async (transactionData) => {
    try {
        console.log("Submitting transaction to API:", transactionData);
        const response = await apiInstance.post('/transactions/', transactionData);
        // console.log("API Response:", response.data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            console.error('API Error Details:', error.response.data); // log the detailed error response
        }
        console.error('Error creating transaction:', error);
        throw error;
    }
};


// export const fetchAccountAuditLog = async () => {
//     try {
//         const response = await apiInstance.get('/accountauditlogs/');
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching account audit logs:', error);
//     }
// }
//
// export const createAccountAuditLog = async (auditLogData) => {
//     try {
//         const response = await apiInstance.post('/accountauditlogs/', auditLogData);
//         return response.data;
//     } catch (error) {
//         console.error('Error creating account audit log:', error);
//     }
// }

export const fetchNotes = async () => {
    try {
        const response = await apiInstance.get('/notes/');
        // console.log('API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching notes:', error);
    }
};

export const createNote = async (note) => {
    try {
        const response = await apiInstance.post('/notes/', note);
        return response.data;
    } catch (error) {
        console.error('Error adding note:', error);
    }
};

export const updateNote = async (id, note) => {
    try {
        const response = await apiInstance.put(`/notes/${id}/`, note);
        return response.data;
    } catch (error) {
        console.error('Error updating note:', error);
    }
};

export const deleteNote = async (noteId) => {
    try {
        await apiInstance.delete(`/notes/${noteId}/`);
    } catch (error) {
        console.error('Error deleting note:', error);
    }
};

export const fetchStockTransfers = async () => {
    const response = await apiInstance.get('/stock-transfers/');
    return response.data;
};

export const createStockTransfer = async (payload) => {
    const response = await apiInstance.post('/stock-transfers/', payload);
    return response.data;
};

export const fetchTransferRequests = async () => {
    const response = await apiInstance.get('/stock-transfer-requests/');
    return response.data;
};

export const createTransferRequest = async (payload) => {
    const response = await apiInstance.post('/stock-transfer-requests/', payload);
    return response.data;
};

export const approveTransferRequest = async (id) => {
    const response = await apiInstance.post(`/stock-transfer-requests/${id}/approve/`);
    return response.data;
};

export const rejectTransferRequest = async (id) => {
    const response = await apiInstance.post(`/stock-transfer-requests/${id}/reject/`);
    return response.data;
};

export const fetchLowStockAlerts = async () => {
    const response = await apiInstance.get('/low-stock-alerts/');
    return response.data;
};


// store-based reorder levels (per active store)
export const fetchStoreProductSettings = async () => {
    const response = await apiInstance.get('/store-product-settings/');
    return response.data;
};

export const upsertStoreProductSetting = async (productId, reorder_level) => {
    // Try to create; if it already exists for this store/product, backend should reject.
    // In that case, the caller can PATCH by id. This helper is minimal; UI can decide strategy.
    const response = await apiInstance.post('/store-product-settings/', {
        product: productId,
        reorder_level,
    });
    return response.data;
};

export const updateStoreProductSetting = async (id, payload) => {
    const response = await apiInstance.patch(`/store-product-settings/${id}/`, payload);
    return response.data;
};

export const fetchAllProductsMinimal = async () => {
    const response = await apiInstance.get('/products/all-minimal/');
    return response.data;
};

export const fetchAllProductsMinimalWithUnits = async () => {
    const response = await apiInstance.get('/products/all-minimal-with-units/');
    return response.data;
};

export const fetchProductReportData = async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.product_id) params.append('product_id', filters.product_id);
    if (filters.store_id) params.append('store_id', filters.store_id);
    if (Array.isArray(filters.compare_product_ids) && filters.compare_product_ids.length > 0) {
        params.append('compare_product_ids', filters.compare_product_ids.join(','));
    }

    const response = await apiInstance.get(`/products/product-report/?${params.toString()}`);
    return response.data;
};

// HR
const unwrapList = (data) => Array.isArray(data) ? data : (data?.results || []);

export const fetchHRDashboard = async () => {
    const response = await apiInstance.get('/hr/dashboard/');
    return response.data;
};

export const fetchHRDepartments = async () => {
    const response = await apiInstance.get('/hr/departments/');
    return unwrapList(response.data);
};

export const createHRDepartment = async (payload) => {
    const response = await apiInstance.post('/hr/departments/', payload);
    return response.data;
};

export const updateHRDepartment = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/departments/${id}/`, payload);
    return response.data;
};

export const deleteHRDepartment = async (id) => {
    const response = await apiInstance.delete(`/hr/departments/${id}/`);
    return response.data;
};

export const fetchHRRoles = async () => {
    const response = await apiInstance.get('/hr/roles/');
    return unwrapList(response.data);
};

export const createHRRole = async (payload) => {
    const response = await apiInstance.post('/hr/roles/', payload);
    return response.data;
};

export const updateHRRole = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/roles/${id}/`, payload);
    return response.data;
};

export const deleteHRRole = async (id) => {
    const response = await apiInstance.delete(`/hr/roles/${id}/`);
    return response.data;
};

export const fetchHRSalaryStructures = async () => {
    const response = await apiInstance.get('/hr/salary-structures/');
    return unwrapList(response.data);
};

export const createHRSalaryStructure = async (payload) => {
    const response = await apiInstance.post('/hr/salary-structures/', payload);
    return response.data;
};

export const updateHRSalaryStructure = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/salary-structures/${id}/`, payload);
    return response.data;
};

export const deleteHRSalaryStructure = async (id) => {
    const response = await apiInstance.delete(`/hr/salary-structures/${id}/`);
    return response.data;
};

export const fetchHREmployees = async (filters = {}) => {
    const response = await apiInstance.get('/hr/employees/', { params: filters });
    return unwrapList(response.data);
};

export const createHREmployee = async (payload) => {
    const response = await apiInstance.post('/hr/employees/', payload);
    return response.data;
};

export const fetchHRAttendance = async (filters = {}) => {
    const response = await apiInstance.get('/hr/attendance/', { params: filters });
    return unwrapList(response.data);
};

export const updateHREmployee = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/employees/${id}/`, payload);
    return response.data;
};

export const createHRAttendance = async (payload) => {
    const response = await apiInstance.post('/hr/attendance/', payload);
    return response.data;
};

export const updateHRAttendance = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/attendance/${id}/`, payload);
    return response.data;
};

export const fetchHRLeaveTypes = async () => {
    const response = await apiInstance.get('/hr/leave-types/');
    return unwrapList(response.data);
};

export const createHRLeaveType = async (payload) => {
    const response = await apiInstance.post('/hr/leave-types/', payload);
    return response.data;
};

export const updateHRLeaveType = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/leave-types/${id}/`, payload);
    return response.data;
};

export const fetchHRLeaveRequests = async (filters = {}) => {
    const response = await apiInstance.get('/hr/leave-requests/', { params: filters });
    return unwrapList(response.data);
};

export const createHRLeaveRequest = async (payload) => {
    const response = await apiInstance.post('/hr/leave-requests/', payload);
    return response.data;
};

export const approveHRLeaveRequest = async (id) => {
    const response = await apiInstance.post(`/hr/leave-requests/${id}/approve/`);
    return response.data;
};

export const rejectHRLeaveRequest = async (id) => {
    const response = await apiInstance.post(`/hr/leave-requests/${id}/reject/`);
    return response.data;
};

export const fetchHRPayrollPeriods = async () => {
    const response = await apiInstance.get('/hr/payroll-periods/');
    return unwrapList(response.data);
};

export const createHRPayrollPeriod = async (payload) => {
    const response = await apiInstance.post('/hr/payroll-periods/', payload);
    return response.data;
};

export const updateHRPayrollPeriod = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/payroll-periods/${id}/`, payload);
    return response.data;
};

export const fetchHRPayrollItems = async (filters = {}) => {
    const response = await apiInstance.get('/hr/payroll-items/', { params: filters });
    return unwrapList(response.data);
};

export const createHRPayrollItem = async (payload) => {
    const response = await apiInstance.post('/hr/payroll-items/', payload);
    return response.data;
};

export const updateHRPayrollItem = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/payroll-items/${id}/`, payload);
    return response.data;
};

export const fetchHRPerformanceReviews = async () => {
    const response = await apiInstance.get('/hr/performance-reviews/');
    return unwrapList(response.data);
};

export const createHRPerformanceReview = async (payload) => {
    const response = await apiInstance.post('/hr/performance-reviews/', payload);
    return response.data;
};

export const fetchHRComplianceDocuments = async () => {
    const response = await apiInstance.get('/hr/compliance-documents/');
    return unwrapList(response.data);
};

export const createHRComplianceDocument = async (payload) => {
    const response = await apiInstance.post('/hr/compliance-documents/', payload);
    return response.data;
};

export const updateHRComplianceDocument = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/compliance-documents/${id}/`, payload);
    return response.data;
};

export const fetchHRJobOpenings = async () => {
    const response = await apiInstance.get('/hr/job-openings/');
    return unwrapList(response.data);
};

export const createHRJobOpening = async (payload) => {
    const response = await apiInstance.post('/hr/job-openings/', payload);
    return response.data;
};

export const updateHRJobOpening = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/job-openings/${id}/`, payload);
    return response.data;
};

export const fetchHRApplicants = async () => {
    const response = await apiInstance.get('/hr/applicants/');
    return unwrapList(response.data);
};

export const createHRApplicant = async (payload) => {
    const response = await apiInstance.post('/hr/applicants/', payload);
    return response.data;
};

export const updateHRApplicant = async (id, payload) => {
    const response = await apiInstance.patch(`/hr/applicants/${id}/`, payload);
    return response.data;
};


